module.exports = __webpack_public_path__ + "static/img/Japan.50ce118.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/destination/Japan.png
// module id = uPQy
// module chunks = 1